import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Paper, Box } from '@mui/material'

import { ApplicationState } from '@/state/root.models'
import useReportsActions from '@/views/reports/hooks/use-reports-actions.hooks'
import ReportsModule from '@/views/reports/index.module'

export const ReportsCasinoByPlayerComponent = () => {
  const { setReportsFilters } = useReportsActions()

  const { playerCard } = useSelector(
    ({ playerCard }: ApplicationState) => playerCard,
  )
  const { filters } = useSelector(({ reports }: ApplicationState) => reports)

  useEffect(() => {
    if (playerCard?.id) {
      setReportsFilters({
        ...filters,
        page: 1,
        playerId: playerCard?.id,
        from: 'playerCard',
      })
    }
  }, [playerCard]) // eslint-disable-line

  return (
    <Box
      component={Paper}
      p={2}
      minHeight="calc(100vh - 168px)"
      display="flex"
      flexDirection="column"
      position="relative"
      borderRadius={2}
    >
      <ReportsModule />
    </Box>
  )
}
